const caseViewRoots = document.querySelectorAll("[data-case-view]");

if (caseViewRoots.length) {
  const hoverPreviewQuery = window.matchMedia(
    "(hover: hover) and (pointer: fine)",
  );

  const playPreviewVideo = (video) => {
    if (!video) return;
    video.play().catch(() => {});
  };

  const pausePreviewVideo = (video) => {
    if (!video) return;
    video.pause();
  };

  caseViewRoots.forEach((root) => {
    const mediaItems = Array.from(
      root.querySelectorAll(".sp-case-view__media-item"),
    );
    const videoItems = mediaItems.filter((item) =>
      item.hasAttribute("data-case-view-preview-video"),
    );
    const previewVideos = videoItems
      .map((item) => item.querySelector(".sp-case-view__media-video"))
      .filter(Boolean);

    if (!mediaItems.length) return;

    previewVideos.forEach(playPreviewVideo);

    if (!hoverPreviewQuery.matches || !videoItems.length) return;

    const clearHoverPreviewState = () => {
      mediaItems.forEach((item) => {
        item.classList.remove("sp-case-view__media-item--dimmed");
      });
      previewVideos.forEach(playPreviewVideo);
    };

    videoItems.forEach((item) => {
      const itemVideo = item.querySelector(".sp-case-view__media-video");

      item.addEventListener("mouseenter", () => {
        mediaItems.forEach((mediaItem) => {
          if (mediaItem === item) {
            mediaItem.classList.remove("sp-case-view__media-item--dimmed");
            playPreviewVideo(itemVideo);
            return;
          }

          mediaItem.classList.add("sp-case-view__media-item--dimmed");
        });

        previewVideos.forEach((video) => {
          if (video === itemVideo) {
            playPreviewVideo(video);
            return;
          }

          pausePreviewVideo(video);
        });
      });

      item.addEventListener("mouseleave", clearHoverPreviewState);
    });
  });

  const galleryRoot = document.createElement("div");
  galleryRoot.className = "sp-case-view-gallery";
  galleryRoot.setAttribute("aria-hidden", "true");
  galleryRoot.innerHTML = `
    <button class="sp-case-view-gallery__backdrop" type="button" aria-label="Close gallery"></button>
    <button class="sp-case-view-gallery__control sp-case-view-gallery__control--close" type="button" aria-label="Close gallery">&times;</button>
    <button class="sp-case-view-gallery__control sp-case-view-gallery__control--prev" type="button" aria-label="Previous media">&#8249;</button>
    <div class="sp-case-view-gallery__viewport"></div>
    <button class="sp-case-view-gallery__control sp-case-view-gallery__control--next" type="button" aria-label="Next media">&#8250;</button>
  `;

  document.body.appendChild(galleryRoot);

  const viewport = galleryRoot.querySelector(".sp-case-view-gallery__viewport");
  const closeButtons = galleryRoot.querySelectorAll(
    ".sp-case-view-gallery__backdrop, .sp-case-view-gallery__control--close",
  );
  const prevButton = galleryRoot.querySelector(
    ".sp-case-view-gallery__control--prev",
  );
  const nextButton = galleryRoot.querySelector(
    ".sp-case-view-gallery__control--next",
  );

  let activeItems = [];
  let activeIndex = 0;
  let activeMediaElement = null;
  let isOpen = false;

  const pauseActiveVideo = () => {
    if (activeMediaElement && activeMediaElement.tagName === "VIDEO") {
      activeMediaElement.pause();
      activeMediaElement.removeAttribute("src");
      activeMediaElement.load();
    }
    activeMediaElement = null;
  };

  const renderActiveSlide = () => {
    if (!viewport || !activeItems.length) return;
    const item = activeItems[activeIndex];
    pauseActiveVideo();
    viewport.innerHTML = "";

    if (item.type === "video") {
      const video = document.createElement("video");
      video.className = "sp-case-view-gallery__video";
      video.controls = true;
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute("webkit-playsinline", "");
      video.setAttribute("preload", "metadata");
      if (item.poster) video.setAttribute("poster", item.poster);

      const source = document.createElement("source");
      source.src = item.src;
      source.type = "video/mp4";
      video.appendChild(source);
      viewport.appendChild(video);
      activeMediaElement = video;
      video.play().catch(() => {});
      return;
    }

    const image = document.createElement("img");
    image.className = "sp-case-view-gallery__image";
    image.src = item.src;
    image.alt = item.alt || "";
    image.loading = "eager";
    viewport.appendChild(image);
    activeMediaElement = image;
  };

  const closeGallery = () => {
    if (!isOpen) return;
    isOpen = false;
    pauseActiveVideo();
    if (viewport) viewport.innerHTML = "";
    galleryRoot.classList.remove("is-active");
    galleryRoot.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  const setIndex = (nextIndex) => {
    if (!activeItems.length) return;
    const total = activeItems.length;
    activeIndex = ((nextIndex % total) + total) % total;
    renderActiveSlide();
  };

  const openGallery = (items, index) => {
    if (!items.length) return;
    activeItems = items;
    activeIndex = index;
    isOpen = true;
    galleryRoot.classList.add("is-active");
    galleryRoot.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    renderActiveSlide();
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-case-view-open]");
    if (!trigger) return;
    const componentRoot = trigger.closest("[data-case-view]");
    if (!componentRoot) return;

    const mediaTriggers = Array.from(
      componentRoot.querySelectorAll("[data-case-view-open]"),
    );
    const items = mediaTriggers
      .map((element) => ({
        src: element.getAttribute("data-gallery-src") || "",
        type: element.getAttribute("data-gallery-type") === "video"
          ? "video"
          : "image",
        poster: element.getAttribute("data-gallery-poster") || "",
        alt: element.getAttribute("data-gallery-alt") || "",
      }))
      .filter((item) => Boolean(item.src));
    const startIndex = Number(trigger.getAttribute("data-case-view-open")) || 0;
    openGallery(items, startIndex);
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeGallery);
  });

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      if (!isOpen) return;
      setIndex(activeIndex - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      if (!isOpen) return;
      setIndex(activeIndex + 1);
    });
  }

  document.addEventListener("keydown", (event) => {
    if (!isOpen) return;
    if (event.key === "Escape") closeGallery();
    if (event.key === "ArrowLeft") setIndex(activeIndex - 1);
    if (event.key === "ArrowRight") setIndex(activeIndex + 1);
  });
}
